import { getData } from '@/utils/axiosUtils';

const getEightByEightLoginLink = async (
    companyId,
    location = window.location.href,
) => {
    return await getData(
        `/company/${companyId}/EightByEightLoginLink?domain=${location}`,
    );
};

export default getEightByEightLoginLink;
